import React from "react";

const Footer: React.FC = () => {
  return (
    <>
      <p>Footer</p>
    </>
  );
};

export default Footer;
